import Routes from "./Routes";
import {MenuDataType} from "./NavbarTypes";

export const MenuData: MenuDataType = [
  {
    title: "Main",
    link: Routes.Main,
    id: "",
    sections: [
      {
        title: "Resolved Flag History",
        link: Routes.MainResolved,
        id: "",
      },
      {
        title: "Machine Break Down Report",
        link: Routes.MainBreakdownReport,
        id: "",
        section: [
          {
            title: "Log options ",
            link: Routes.MainLogOptions,
            id: "",
          },
        ],
      },
      {
        title: "Machine Daily Loss Report",
        link: Routes.MainDialyLossReport,
        id: "",
        section: [
          {
            title: "Log options ",
            link: Routes.MainLogOptions,
            id: "",
          },
        ],
      },
    ],
  },
];
